import request from '@utils/request'
import configRequest from "@src/config/request";
import { getLocalStorage, saveLocalStorage } from "@utils/localStorage";

export const state = {
  menuSolution: [],
  menuProduct: [],
  menuBrand: [],
  currentSetting: null
};

export const mutations = {
  SET_MENU(state, newValue) {
    state.menuSolution = newValue.solution_category;
    state.menuProduct = newValue.product_parent_category;
    state.menuBrand = newValue.brand;
  },
  SET_CURRENT_SETTING(state, newValue) {
    state.currentSetting = newValue;
    saveLocalStorage('site.setting', newValue.sitename);
  },
};

export const getters = {};

export const actions = {
  setMenu({ commit }, menu) {
    commit('SET_MENU', menu)
  },

  contact({ commit }, data) {
    return request.post('/customer/message/send', data)
  },

  // fetchStaticItem({ commit }, article) {
  //   return request.get(`/item/${ article }/list`)
  //     .then((response) => response.items)
  // },

  fetchSetting({ commit, state }) {
    const cached = state.currentSetting;
    const hasCached = !!cached;
    
    return hasCached
      ? state
      : request.post(
        '/setting/search',
        {
          url: process.env.NODE_ENV === 'development' ? 'http://solution.zerone2021.test' : window.globalData.APP_URL
        },
        {
          ...configRequest,
          name: 'fetchSetting'
        }
      )
        .then((response) => {
          commit('SET_CURRENT_SETTING', response.items);

          return response
        })
  },


  fetchKeyword({ commit }, data) {
    return request.post('/iot/tag/items/search', data)
      .then((response) => response)
  },

  // searchArticle({ commit }, data) {
  //   return request.post('/site/search', data)
  //     .then(({ items, pagination }) => {
  //       return {
  //         items,
  //         pagination
  //       }
  //     })
  // },

  fetchHome({ commit }, data) {
    return request.get(`iot/homepage`)
      .then((response) => response.items)
  },


  fetchFile({ commit }, { params, responseType = 'blob' } = {}) {
    return request.post(`/iot/resource/file/download`, {...params}, { responseType })
      .then((response) => response)
  },
  // fetchFile({ commit }, { params, responseType = 'blob' } = {}) {
  //   return request.post(`/iot/resource/file/download`, {...params})
  //     .then((response) => response)
  // },
};
